import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const SectionTen = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });


    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });


    const cardsData2 = [
        {
            icon: "assets/images/keinternational/shield.svg",
            headline: "PCI DSS-compliant",
        },
        {
            icon: "assets/images/keinternational/text.svg",
            headline: "Smart, contextual messages only. No cold outreach",
        },
        {
            icon: "assets/images/keinternational/user.svg",
            headline: "<5% opt-out rate across a 165M+ shopper network",
        },

    ];


    return (
        <div className="section-ten-Ind">
            <div className="container-fluid">
                <div className="mid-text3-Ind w-full md:w-6 mt-10" style={{ margin: isMobile ? '0px 0.2rem' : "0px 5rem" }}>
                    <h1 className="text-left">Built for Privacy. Designed for Trust.</h1>
                    <p className="text-left">No one wants spammy messages. That’s why <br /> KwikEngage is consent-first, not push-first.</p>
                </div>

                <div className="info-section-Ind">
                    <div className="card-wrapper">
                        {cardsData2.map((card, idx) => (
                            <div className="info-card-Ind" key={idx}>
                                <img src={card.icon} alt="" className="info-icon" />
                                <p className="info-text-Ind">{card.headline}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
